
























































































/** @format */
import { Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
// 下拉框封装组件
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';

import { statRecordPageList, statRecordExport } from '@/api/discount-management/index';
import { couponTypeMap } from '@/types/discount-management/dictionaries';
import Utils from '@root/utils/common';
import PlateInput from '@/components/plate-input/index.vue';
import CountCardSimpleGrid from '@/components/count-card/simple-grid.vue';
import moment from 'moment';
import * as _ from 'lodash';
@Component({
  name: 'CouponCount',
  components: { ParkingLotSearch, PlateInput, CountCardSimpleGrid }
})
export default class CouponCount extends Mixins(TableMixin, TableWidthMixin) {
  private filterParam: any = {
    parkIds: [], //选中的车场
    merchantName: '',
    types: [],
    startDate: moment(new Date().getTime() - 24 * 60 * 60 * 1000).format('YYYY-MM-DD'), // 开始时间
    endDate: moment(new Date().getTime() - 24 * 60 * 60 * 1000).format('YYYY-MM-DD') // 结束时间
  };
  // options = Utils.toLabelVal(couponTypeMap)
  // options = _.filter(
  //   Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_merchant_coupon_coupon_type),
  //   function(o) {
  //     return o.value != '04';
  //   }
  // );
  options = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_merchant_coupon_coupon_type);
  private tableLoading: boolean = false;
  tableData: any[] = [];
  totalCount: any[] = [];
  canExport: boolean = true;
  //搜索时间配置
  private onTimeChange(date: any, dateString: any) {
    console.log(dateString);
    let [operateTimeStart, operateTimeEnd] = dateString;
    this.filterParam.startDate = operateTimeStart;
    this.filterParam.endDate = operateTimeEnd;
  }
  get defaultTime() {
    if (this.filterParam.startDate && this.filterParam.endDate) {
      return [
        this.moment(this.filterParam.startDate, 'YYYY-MM-DD'),
        this.moment(this.filterParam.endDate, 'YYYY-MM-DD')
      ];
    } else if (this.filterParam.startDate) {
      return [this.moment(this.filterParam.startDate, 'YYYY-MM-DD')];
    } else {
      return [];
    }
  }
  set defaultTime(val: any) {}
  private moment = moment;

  private disabledDate(current: any) {
    return current && current >= moment().endOf('day');
  }
  //table列表
  get tableColums() {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '统计日期',
        dataIndex: 'date',
        width: 180,
        customRender: (text: any) => text || '--'
      },
      {
        title: '所属车场',
        dataIndex: 'parkName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '商户名称',
        dataIndex: 'merchantName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },

      {
        title: '优惠券类型',
        dataIndex: 'type',
        width: 180,
        customRender: (text: any) => text || '--'
      },
      {
        title: '发放总张数',
        dataIndex: 'sendNum',
        width: 140,
        customRender: (text: any) => `${text}张` || '--'
      },
      {
        title: '使用总张数',
        dataIndex: 'useNum',
        width: 180,
        customRender: (text: any) => `${text}张` || '--'
      },
      {
        title: '实际优惠金额',
        dataIndex: 'currDiscountPrice',
        width: 200,
        customRender: (text: any) => `${text}` || '--'
      },
      {
        title: '总结算金额',
        dataIndex: 'statPrice',
        width: 120,
        customRender: (text: any) => {
          if (text) {
            return `${text}`;
          }
          return '--';
        }
      }
    ];
  }
  //table初始化
  async fetchTableData(refresh?: any) {
    if (refresh) this.current = 1;
    if (this.tableLoading) return;
    this.tableLoading = true;
    try {
      const { parkIds, types, ...rest } = this.filterParam;
      const { status, code, msg, data } = await statRecordPageList({
        ...rest,
        types: this.filterParam.types.join(','),
        parkIds: this.filterParam.parkIds.join(','),
        page: this.current,
        pageSize: this.pageSize
      });
      const {
        datas,
        totalNum,
        totalPage,
        currPage,
        pageSize,
        sendCount,
        useCount,
        discountTotalPrice,
        statTotalPrice
      } = data;
      this.total = totalNum - 0;
      this.current = currPage - 0;
      this.pageSize = pageSize - 0;
      this.tableData = datas;
      this.totalCount = [];
      this.totalCount.push(
        { title: '总发放（张）', count: sendCount || 0, countColor: 'warning' },
        { title: '总使用（张）', count: useCount || 0, countColor: 'primary' },
        { title: '总优惠金额（张）', count: discountTotalPrice || 0, countColor: 'primary' },
        { title: '总结算金额（张）', count: statTotalPrice || 0, countColor: 'primary' }
      );
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }
  //点击搜索
  searchTable() {
    this.fetchTableData(true);
  }
  //清空table
  onTableFilterClear({ defaultParkIdList }) {
    this.filterParam = {
      parkIds: defaultParkIdList, //选中的车场
      merchantName: '',
      types: [],
      startDate: moment(new Date().getTime() - 24 * 60 * 60 * 1000).format('YYYY-MM-DD'), // 开始时间
      endDate: moment(new Date().getTime() - 24 * 60 * 60 * 1000).format('YYYY-MM-DD') // 结束时间
    };
    this.searchTable();
  }
  //分页
  handleTableChange(val: any) {
    this.current = val.current;
    this.pageSize = val.pageSize;
    this.fetchTableData();
  }
  private async downLoad() {
    try {
      this.canExport = false;
      const { parkIds, types, ...rest } = this.filterParam;
      this.canExport = true;
      await statRecordExport(
        {
          ...rest,
          types: this.filterParam.types.join(','),
          parkIds: this.filterParam.parkIds.join(','),
          currPage: this.current,
          pageSize: this.pageSize
        },
        '优惠券统计'
      );
    } catch (e) {
      this.canExport = true;
      console.log('couponExport', '导出失败');
    }
  }
  created() {
    this.fetchTableData();
  }
}
